// --------------------------------------------------------
// src/routes/router.js
//
// Display content relative to the URL
// This is where we define the routes and methods for our
// application.
// --------------------------------------------------------
"use strict";

const ReadsRouter = Backbone.Router.extend({

	// The routes matching a URL and the method called
	routes: {
		""					: "index",
		"book/:id"			: "bookShow",
		"books"				: "showAllBooks",
		"findBy/(:filter)"	: "filterBooks",
		"search/(:keyword)"	: "searchBooks",
		"theme/:theme"		: "themeShow",
		"credits"			: "creditsIndex",
		"author/:name"		: "authorShow",
		"*notFound"			: "notFound"
	},

	_bindRoutes: function() {
		// this._bindRoutes() is called in Backbone.Router before
		// initialize(). Overriding native _bindRoutes method to
		// accomodate the custom logic in changing route.
		let self = this;

		_.each(_.keys(this.routes), function(key) {
				for (let l in app.getSupportedLanguages()) {
					// We need to catch the base url here
					if (key === "") {
						// index.html#<language> and index.html#<language>/ should be accepted
						self.routes[app.getSupportedLanguages()[l]] = self.routes[key];
						self.routes[app.getSupportedLanguages()[l] + "/"] = self.routes[key];
					} else {
						self.routes[app.getSupportedLanguages()[l] + "/" + key] = self.routes[key];
					}
				}
				delete self.routes[key];
		});

		// Call native _bindRoutes method.
		Backbone.Router.prototype._bindRoutes.apply(this, arguments);
	},

	execute: function(callback, args, name) {
		// We change the language only if the original value has changed
		// TODO: catch limit cases where match returns null
		if (window.location.hash.match("#[a-z]{2}")[0].replace("#", "") !== app.getLanguage()) {
			app.changeLanguage(window.location.hash.match("#[a-z]{2}")[0].replace("#", ""));
		}

		if (callback) callback.apply(this, args);
	},

	// Display all books written by a specific author
	authorShow: function(name) {
		var coll, page;

		// Find all the books written by the given author
		coll = window.BOOKCOLLECTION.filterBy("authors", [name]);

		// The page will be an error page if the collection is empty
		page = coll.isEmpty() ?
					new NoBooksErrorPage() : 
					new BooksPage({ collection: coll });
	
		app.display(page);
	},

	// Display a specific book
	bookShow: function(id) {
		var page, book;

		book = window.BOOKCOLLECTION.get(id);
		page = book ? 
				new BookShowPage({ model: book }) :
				new NoBookErrorPage();

		app.display(page);
	},

	// Display the credit to the authors and publishers
	creditsIndex: function() {
		app.display(new CreditsPage({ authors: AuthorCollection.all(), publishers: BookRepository.getArrPublishers() }));
	},

	// Filter the books
	// Still work to be done here.
	// The same object (filters) is being distributed on two different components
	filterBooks: function(filterString) {
		var bookCollection, page, coll;

		// We want to copy the content of the base BOOKCOLLECTION which should never change
		bookCollection = window.BOOKCOLLECTION;
		// We want to return all the books if no filters are specified
		if (!empty(filterString)) {
			app.components.filters.updateView(filterString);
		}
		// Create an empty result list
		coll = app.components.filters.exec(bookCollection);

		// if the collection is empty, then the page will be an error view
		page = coll.isEmpty() ? 
				new NoBooksErrorPage() : 
				new FilteredBooksPage({ collection: coll, filters: app.components.filters.active });
	
		app.display(page);
	},

	// Display the homepage
	index: function() {
		var page, coll;

		coll = window.THEMECOLLECTION;
		page = new HomePage({ collection: coll });

		app.display(page);
	},

	// The page displayed for all non-matched routes
	notFound: function() {
		app.display(new Error404Page());
	},

	// Filter the books with a keyword
	searchBooks: function(value) {
		var results, page;

		// Operate a general keyword search
		if (!_.isEmpty(value)) {
			results = window.BOOKCOLLECTION.search([value], ["title", "authors", "theme", "year", "country"]);
		} else {
			results = window.BOOKCOLLECTION;
		}

		page = results.length === 0 && !empty(value) ?
				new NoBooksErrorPage() :
				new SearchResultsPage({ collection: results });

		app.display(page);
		
		return this;
	},

	// Display all books
	showAllBooks: function() {
		app.display(new BooksPage({ collection: window.BOOKCOLLECTION }));
	},

	// Display all books relative to a specific theme
	themeShow: function(theme) {
		var bookCollection, books, page;

		// Search all the books corresponding to the selected theme and shuffle them
		books = window.BOOKCOLLECTION.search(theme, ["theme"]).shuffle();
		bookCollection = new BookCollection(books);

		page = !_.isEmpty(books) ? 
				new BooksPage({ collection: bookCollection }) :
				new NoThemesErrorPage();
		
		app.display(page);
	},

});
